import { render, staticRenderFns } from "./faqList.vue?vue&type=template&id=39ce3b18&scoped=true&"
import script from "./faqList.vue?vue&type=script&lang=js&"
export * from "./faqList.vue?vue&type=script&lang=js&"
import style0 from "./faqList.vue?vue&type=style&index=0&id=39ce3b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce3b18",
  null
  
)

export default component.exports